const MEDIA_QUERIES = {
  small: '(max-width: 1079px)',
  large: '(min-width: 1080px)'
};

export { MEDIA_QUERIES };
